import __variableDynamicImportRuntimeHelper from "./dynamic-import-helper.js";
import { jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Localization } from "@bynder/localization";
import en_US from "./en_US.json.js";
const supportedLocales = ["de_DE", "en_US", "es_ES", "es_MX", "fr_FR", "it_IT", "ja_JP", "ko_KR", "nl_NL", "pl_PL", "pt_BR", "ru_RU", "tr_TR", "zh_CN", "zh_TW"];
const LocalizationContext = React.createContext(void 0);
function LocalizationProvider({
  children,
  locale = "en_US"
}) {
  const [translations, setTranslations] = useState(process.env.NODE_ENV === "test" ? en_US : void 0);
  useEffect(() => {
    if (process.env.NODE_ENV !== "test") {
      if (supportedLocales.includes(locale)) {
        __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({
          "../../i18n/de_DE.json": () => import("./de_DE.json.js"),
          "../../i18n/en_US.json": () => import("./en_US.json.js"),
          "../../i18n/es_ES.json": () => import("./es_ES.json.js"),
          "../../i18n/es_MX.json": () => import("./es_MX.json.js"),
          "../../i18n/fr_FR.json": () => import("./fr_FR.json.js"),
          "../../i18n/it_IT.json": () => import("./it_IT.json.js"),
          "../../i18n/ja_JP.json": () => import("./ja_JP.json.js"),
          "../../i18n/ko_KR.json": () => import("./ko_KR.json.js"),
          "../../i18n/nl_NL.json": () => import("./nl_NL.json.js"),
          "../../i18n/pl_PL.json": () => import("./pl_PL.json.js"),
          "../../i18n/pt_BR.json": () => import("./pt_BR.json.js"),
          "../../i18n/ru_RU.json": () => import("./ru_RU.json.js"),
          "../../i18n/tr_TR.json": () => import("./tr_TR.json.js"),
          "../../i18n/zh_CN.json": () => import("./zh_CN.json.js"),
          "../../i18n/zh_TW.json": () => import("./zh_TW.json.js")
        }), `../../i18n/${locale}.json`).then((response) => {
          setTranslations(response.default);
        });
      } else {
        import("./en_US.json.js").then((response) => {
          setTranslations(response.default);
        });
      }
    }
  }, [locale]);
  if (!translations) {
    return null;
  }
  const localization = new Localization(translations, locale);
  return /* @__PURE__ */ jsx(LocalizationContext.Provider, {
    value: localization,
    children
  });
}
export {
  LocalizationContext,
  LocalizationProvider
};
//# sourceMappingURL=localization.js.map
